"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveUserNote = exports.getProfileData = exports.deleteAvatar = exports.banUser = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _csrfToken = require("@insided/deprecated-preact-components/utils/csrfToken");

var getProfileData = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(userId) {
    var _yield$axios$get, data;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get('/member/profile', {
              params: {
                yip_csrf_token: (0, _csrfToken.csrfToken)(),
                userid: userId,
                json: true
              }
            });

          case 2:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getProfileData(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getProfileData = getProfileData;

var deleteAvatar = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(userId) {
    var params, _yield$axios$post, data;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            params = new URLSearchParams({
              yip_csrf_token: String((0, _csrfToken.csrfToken)()),
              avatardeleteuserid: String(userId)
            });
            _context2.next = 3;
            return _axios.default.post('/member/avatarDelete', params);

          case 3:
            _yield$axios$post = _context2.sent;
            data = _yield$axios$post.data;
            return _context2.abrupt("return", data);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function deleteAvatar(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.deleteAvatar = deleteAvatar;

var banUser = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(userId) {
    var params, _yield$axios$post2, data;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            params = new URLSearchParams({
              yip_csrf_token: String((0, _csrfToken.csrfToken)()),
              banuserid: String(userId)
            });
            _context3.next = 3;
            return _axios.default.post('/member/banuser', params);

          case 3:
            _yield$axios$post2 = _context3.sent;
            data = _yield$axios$post2.data;
            return _context3.abrupt("return", data);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function banUser(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.banUser = banUser;

var saveUserNote = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(message, userId) {
    var params, _yield$axios$post3, data;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            params = new URLSearchParams({
              yip_csrf_token: String((0, _csrfToken.csrfToken)()),
              message: message,
              loguserid: String(userId)
            });
            _context4.next = 3;
            return _axios.default.post('/member/note', params);

          case 3:
            _yield$axios$post3 = _context4.sent;
            data = _yield$axios$post3.data;
            return _context4.abrupt("return", data);

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function saveUserNote(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

exports.saveUserNote = saveUserNote;